// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar */
.navbar-brand {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-mobile {
  display: none;
}

@media (max-width: 767px) {
  .logo-mobile {
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo-mobile > img {
    height: 24px;
  }
  .navbar-header {
    display: none;
  }
  .navbar-header:before {
    height: auto !important;
  }
  .tgl-menu-btn {
    top: 0;
    left: 0;
  }
  .mainnav-toggle {
    z-index: 2;
  }
  #mainnav-container {
    padding: 0;
  }
  .mainnav-in {
    left: 0;
  }
}
.navbar-brand > svg {
  height: 26px;
  width: 107px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  top: 12px;
  right: 0;
}

.brand-icon {
  width: 50px;
  height: 50px;
}

.brand-text {
  line-height: 50px;
}

.navbar-top-links > li > a {
  height: 50px;
  color: #7f47d1;
}

.navbar-top-links .tgl-menu-btn > a {
  color: #7f47d1;
}

.navbar-header:before {
  height: 50px;
  background: rgb(0, 208, 255);
  background: -webkit-gradient(left bottom, right top, color-stop(0%, rgb(0, 208, 255)), color-stop(60%, rgb(134, 74, 255)), color-stop(100%, rgb(176, 29, 255)));
  background: linear-gradient(45deg, rgb(0, 208, 255) 0%, rgb(134, 74, 255) 60%, rgb(176, 29, 255) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#00d0ff", endColorstr="#b01dff", GradientType=1);
}

/* LOGO SVG */
.pague-la-texto {
  opacity: 1;
  transition: transform 0.25s ease-in, opacity 0.25s linear;
}

.pague-la-texto.active {
  transform: translateX(-255px);
  opacity: 0;
}

.objeto-logo-paguela.active {
  animation: shake 0.25s ease;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-3px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(3px, 0, 0);
  }
}
.hamburger:hover {
  opacity: 1;
}

.hamburger-box {
  width: 22px;
  height: 18px;
  margin: 0 3px;
}

.hamburger--slider .hamburger-inner::before {
  transition: none;
}

.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
  transition-duration: 0.25s;
  background-color: #7f47d1;
}

.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
  width: 22px;
  height: 2px;
}

.hamburger--slider .hamburger-inner {
  top: 6px;
}

.hamburger--slider.is-active .hamburger-inner {
  top: 2px;
}

.hamburger--slider .hamburger-inner::before {
  top: 6px;
}

.hamburger--slider .hamburger-inner::after {
  top: 12px;
}

.hamburger--slider.is-active .hamburger-inner::after {
  top: 20px;
}

/* botao sair */
.sair {
  cursor: pointer;
}

.sair svg {
  height: 16px;
  width: 20px;
}

.sair .username {
  color: #808080;
  transition: color 0.25s ease;
}

.sair svg * {
  transition: fill 0.25s ease;
}

.sair a:hover svg *, .sair a:focus svg *, .sair a:active svg * {
  fill: #7f47d1 !important;
}

.sair a:hover, .sair a:focus, .sair a:active {
  background-color: #fff;
}

.sair a:hover .username, .sair a:focus .username, .sair a:active .username {
  color: #7f47d1;
}

.sair .text-right {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/navbar/navbar.component.scss"],"names":[],"mappings":"AAAA,WAAA;AAEA;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,SAAA;IACA,UAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EAAN;EAEE;IACI,YAAA;EAAN;EAEE;IACI,aAAA;EAAN;EAEE;IACI,uBAAA;EAAN;EAEE;IACI,MAAA;IACA,OAAA;EAAN;EAEE;IACI,UAAA;EAAN;EAEE;IACI,UAAA;EAAN;EAEE;IACI,OAAA;EAAN;AACF;AAGA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,YAAA;EACA,cAAA;AADJ;;AAIA;EACI,cAAA;AADJ;;AAIA;EACI,YAAA;EACA,4BAAA;EAEA,+JAAA;EAIA,sGAAA;EACA,mHAAA;AADJ;;AAKA,aAAA;AAEA;EACI,UAAA;EACA,yDAAA;AAHJ;;AAMA;EACI,6BAAA;EACA,UAAA;AAHJ;;AAMA;EACI,2BAAA;EACA,+BAAA;AAHJ;;AAMA;EACI;IACI,kCAAA;EAHN;EAKE;IACI,iCAAA;EAHN;AACF;AAMA;EACI,UAAA;AAJJ;;AAOA;EACI,WAAA;EACA,YAAA;EACA,aAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,0BAAA;EACA,yBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,WAAA;AAJJ;;AAOA;EACI,QAAA;AAJJ;;AAOA;EACI,QAAA;AAJJ;;AAOA;EACI,QAAA;AAJJ;;AAOA;EACI,SAAA;AAJJ;;AAOA;EACI,SAAA;AAJJ;;AAOA,eAAA;AACA;EACI,eAAA;AAJJ;;AAOA;EACI,YAAA;EACA,WAAA;AAJJ;;AAOA;EACI,cAAA;EACA,4BAAA;AAJJ;;AAOA;EACI,2BAAA;AAJJ;;AAOA;EACI,wBAAA;AAJJ;;AAOA;EACI,sBAAA;AAJJ;;AAOA;EACI,cAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;AAJJ","sourcesContent":["/* Navbar */\n\n.navbar-brand {\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.logo-mobile {\n    display: none;\n}\n\n@media (max-width: 767px) {\n    .logo-mobile {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        margin: 0;\n        padding: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .logo-mobile > img {\n        height: 24px;\n    }\n    .navbar-header {\n        display: none;\n    }\n    .navbar-header:before {\n        height: auto !important;\n    }\n    .tgl-menu-btn {\n        top: 0;\n        left: 0;\n    }\n    .mainnav-toggle {\n        z-index: 2;\n    }\n    #mainnav-container {\n        padding: 0;\n    }\n    .mainnav-in {\n        left: 0;\n    }\n}\n\n.navbar-brand > svg {\n    height: 26px;\n    width: 107px;\n    position: absolute;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    top: 12px;\n    right: 0;\n}\n\n.brand-icon {\n    width: 50px;\n    height: 50px;\n}\n\n.brand-text {\n    line-height: 50px;\n}\n\n.navbar-top-links > li > a {\n    height: 50px;\n    color: #7f47d1;\n}\n\n.navbar-top-links .tgl-menu-btn > a {\n    color: #7f47d1;\n}\n\n.navbar-header:before {\n    height: 50px;\n    background: rgba(0, 208, 255, 1);\n    background: -moz-linear-gradient(45deg, rgba(0, 208, 255, 1) 0%, rgba(134, 74, 255, 1) 60%, rgba(176, 29, 255, 1) 100%);\n    background: -webkit-gradient(left bottom, right top, color-stop(0%, rgba(0, 208, 255, 1)), color-stop(60%, rgba(134, 74, 255, 1)), color-stop(100%, rgba(176, 29, 255, 1)));\n    background: -webkit-linear-gradient(45deg, rgba(0, 208, 255, 1) 0%, rgba(134, 74, 255, 1) 60%, rgba(176, 29, 255, 1) 100%);\n    background: -o-linear-gradient(45deg, rgba(0, 208, 255, 1) 0%, rgba(134, 74, 255, 1) 60%, rgba(176, 29, 255, 1) 100%);\n    background: -ms-linear-gradient(45deg, rgba(0, 208, 255, 1) 0%, rgba(134, 74, 255, 1) 60%, rgba(176, 29, 255, 1) 100%);\n    background: linear-gradient(45deg, rgba(0, 208, 255, 1) 0%, rgba(134, 74, 255, 1) 60%, rgba(176, 29, 255, 1) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00d0ff', endColorstr='#b01dff', GradientType=1);\n}\n\n\n/* LOGO SVG */\n\n.pague-la-texto {\n    opacity: 1;\n    transition: transform 0.25s ease-in, opacity 0.25s linear;\n}\n\n.pague-la-texto.active {\n    transform: translateX(-255px);\n    opacity: 0;\n}\n\n.objeto-logo-paguela.active {\n    animation: shake 0.25s ease;\n    transform: translate3d(0, 0, 0);\n}\n\n@keyframes shake {\n    10%, 90% {\n        transform: translate3d(-3px, 0, 0);\n    }\n    40%, 60% {\n        transform: translate3d(3px, 0, 0);\n    }\n}\n\n.hamburger:hover {\n    opacity: 1;\n}\n\n.hamburger-box {\n    width: 22px;\n    height: 18px;\n    margin: 0 3px;\n}\n\n.hamburger--slider .hamburger-inner::before {\n    transition: none;\n}\n\n.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {\n    transition-duration: 0.25s;\n    background-color: #7f47d1;\n}\n\n.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {\n    width: 22px;\n    height: 2px;\n}\n\n.hamburger--slider .hamburger-inner {\n    top: 6px;\n}\n\n.hamburger--slider.is-active .hamburger-inner {\n    top: 2px;\n}\n\n.hamburger--slider .hamburger-inner::before {\n    top: 6px;\n}\n\n.hamburger--slider .hamburger-inner::after {\n    top: 12px;\n}\n\n.hamburger--slider.is-active .hamburger-inner::after {\n    top: 20px;\n}\n\n/* botao sair */\n.sair {\n    cursor: pointer;\n}\n\n.sair svg {\n    height: 16px;\n    width: 20px;\n}\n\n.sair .username {\n    color: #808080;\n    transition: color .25s ease;\n}\n\n.sair svg * {\n    transition: fill .25s ease;\n}\n\n.sair a:hover svg *, .sair a:focus svg *, .sair a:active svg * {\n    fill: #7f47d1 !important;\n}\n\n.sair a:hover, .sair a:focus, .sair a:active {\n    background-color: #fff;\n}\n\n.sair a:hover .username, .sair a:focus .username, .sair a:active .username {\n    color: #7f47d1;\n}\n\n.sair .text-right {\n    display: flex;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
